import  styled from "styled-components";

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    padding: 4em;
    text-align: center;
    width: 80%;
    max-width: 650px;
    margin: auto;
`;

export const Title = styled.h1`
    
    font-size: 3rem;
    margin-bottom: 0;
    
`;

export const SubTitle = styled.h2`
    font-size: 1.6rem;
    margin-bottom: 0;
`;
